module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27451",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7145",
      "conversations-error-reporting": "static-1.8431",
      "conversations-internal-pub-sub": "static-1.15505",
      "conversations-internal-schema": "static-1.12164",
      "conversations-message-history": "static-1.11025",
      "conversations-test-sdk": "static-1.9949",
      "conversations-visitor-experience-components": "static-1.20814",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5023",
      "hs-test-utils": "static-1.7447",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10972",
      "I18n": "static-7.1478",
      "jasmine-immutable": "static-1.2467",
      "jasmine-runner": "static-1.5871",
      "quartz": "static-1.6283",
      "react-dlb": "static-1.64",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.4008",
      "viral-links-lib": "static-1.6446",
      "visitor-ui-component-library": "static-1.5661",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.4113",
      "atom": "static-1.4630",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4279",
      "conversations-infrastructure": "static-1.8454",
      "conversations-prop-types": "static-1.6879",
      "conversations-visibility-tools": "static-1.5240",
      "conversations-visitor-message-history": "static-1.19551",
      "cssUtils": "static-1.628",
      "enviro": "static-4.345",
      "flux-actions": "static-1.290",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16146",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4892",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3907",
      "sanitize-text": "static-1.7654",
      "signup-constants": "static-1.17855",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.478",
      "usage-tracker": "static-1.6870",
      "usage-tracker-core": "static-1.6720",
      "usage-tracker-multi": "static-1.5284",
      "usage-tracker-public": "static-1.6681",
      "visitor-ui-component-library-icons": "static-1.5472",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2994",
      "moment": "static-3.26",
      "quartz-config": "static-1.61",
      "quartz-core": "static-1.5502",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4321",
      "foundations-components": "static-1.7011",
      "foundations-theming": "static-1.3858",
      "UIComponents": "static-3.7919",
      "cv-backend-services": "static-1.1383",
      "immutable-less": "static-1.4058",
      "conversations-skeleton-state": "static-1.6805",
      "crm-events-viz-core": "static-1.31642",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4154",
      "tanstack-virtual": "static-1.19",
      "ui-images": "static-2.990",
      "permission-components": "static-1.4817",
      "react-virtualized": "static-2.86",
      "HeadJS": "static-2.641",
      "framer-motion": "static-1.57",
      "hs-test-utils-bend-plugin": "static-1.2558",
      "msw": "static-1.39",
      "testing-library": "static-1.139",
      "i18n-data": "static-1.211",
      "moment-timezone": "static-5.72",
      "jasmine": "static-4.3775",
      "signup-ui-url-generator": "static-2.7542",
      "HubStyle": "static-2.11280",
      "sassPrefix": "static-1.145",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3483",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5287",
      "bender-build-tools": "static-1.2637",
      "dispatcher": "static-1.125",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.718",
      "hub-http-shared-msw-handlers": "static-1.8746",
      "hubspotter-http": "static-1.4125",
      "hubspotter-http-shared-msw-handlers": "static-1.8744",
      "mobile-manifest-mixins": "static-1.414",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "hs-story-utils": "static-1.8866",
      "bend-plugin-foundations-components": "static-1.3280",
      "floating-ui": "static-1.45",
      "foundations-theming-specialty": "static-1.1574",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2341",
      "foundations-theming-base": "static-1.2843",
      "stylex": "static-1.21",
      "ts-schema": "static-1.3659",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2001",
      "content-assistance-lib": "static-1.7110",
      "crm-component-utils": "static-1.37778",
      "crm-display-components": "static-1.23528",
      "crm-fe-perf": "static-1.22431",
      "crm-links": "static-1.5683",
      "crm-message-bus": "static-1.41610",
      "crm-search-service-types": "static-1.753",
      "crm-source-interpretation-lib": "static-1.4768",
      "customer-data-communicator": "static-1.44158",
      "customer-data-email": "static-1.17124",
      "customer-data-filters-ui": "static-1.37925",
      "customer-data-objects": "static-1.7140",
      "customer-data-objects-ui-components": "static-1.12491",
      "customer-data-properties": "static-1.49914",
      "customer-data-rte": "static-1.31779",
      "customer-data-ui-utilities": "static-1.9265",
      "data-fetching-client": "static-1.9173",
      "draft-plugins": "static-2.20754",
      "file-manager-components": "static-1.22073",
      "FileManagerCore": "static-1.37572",
      "frontend-preferences-client": "static-1.7453",
      "hubspot-apollo-client": "static-1.4309",
      "hubspot-prosemirror": "static-1.16843",
      "object-comments-thread-lib": "static-1.9417",
      "reference-resolvers-lite": "static-1.7542",
      "ui-addon-upgrades": "static-9.17151",
      "universal-associations-select": "static-1.10470",
      "graphql": "static-1.71",
      "ai-components-ui-library": "static-1.7583",
      "superstore": "static-1.4228",
      "ui-addon-video-player": "static-1.8263",
      "ui-coaching-tips": "static-1.27164",
      "card-properties-lib": "static-1.42768",
      "crm-actions": "static-1.5683",
      "crm-cards-data": "static-1.628",
      "crm-cards-sdk": "static-1.42122",
      "customer-data-properties-shared-msw-handlers": "static-1.8073",
      "customer-data-property-utils": "static-1.7492",
      "customer-data-tracking": "static-1.6382",
      "framework-data-schema-resolvers": "static-1.6332",
      "usage-tracker-container": "static-1.6860",
      "framework-data-table": "static-2.10769",
      "location-customization-utils-lib": "static-1.7716",
      "calling-error-reporting": "static-1.30811",
      "calling-internal-common": "static-1.30805",
      "calling-usage-tracker": "static-1.6017",
      "crm_data": "static-4.90360",
      "crm_schema": "static-3.90399",
      "crm-legacy-global-containers": "static-1.23296",
      "customer-data-content": "static-1.26315",
      "draft-content-plugins": "static-1.27156",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23143",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22851",
      "EmailSignatureEditor": "static-1.23412",
      "FileManagerLib": "static-1.37713",
      "hubspot-prosemirror-plugins": "static-1.16835",
      "integration-settings-components": "static-1.13892",
      "integrations-lib": "static-1.14616",
      "integrations-tracking-lib": "static-1.5120",
      "native-integrations-shared-strings": "static-1.7269",
      "nav-meta": "static-1.28176",
      "outreach-assistant-email-generation": "static-1.5241",
      "property-translator": "static-1.4869",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36335",
      "react-colorpicker": "static-2.9726",
      "react-dnd-compat": "static-1.4114",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7707",
      "rich-text-lib": "static-1.18894",
      "sales-email-signature-service-client": "static-1.3386",
      "sequences-lib": "static-1.7271",
      "timezone-utils": "static-2.4682",
      "ui-addon-i18n": "static-1.10516",
      "ui-addon-iframeable": "static-1.8419",
      "ui-business-units-lib": "static-1.8444",
      "ui-gdpr-components": "static-1.9762",
      "ui-shepherd-react": "static-3.9578",
      "user-context": "static-1.4627",
      "whatsapp-sending-lib": "static-1.4185",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4192",
      "salesImages": "static-1.514",
      "customer-data-filters-ui-msw-helpers": "static-1.20359",
      "customer-data-reference-ui-components": "static-1.12557",
      "FormUrlGenerator": "static-2.4171",
      "framework-builder-read-service-client": "static-1.3548",
      "framework-data-schema-quick-fetch": "static-1.6237",
      "inbound-db-meta-service-client": "static-1.3233",
      "inbound-db-properties-service-client": "static-1.3457",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.500",
      "onboarding-tours": "static-1.15892",
      "reporting-datasets-permissions-lib": "static-1.12178",
      "SharedI18nStrings": "static-1.175",
      "ui-addon-teams": "static-1.20865",
      "calling-global-api": "static-1.62774",
      "calling-lifecycle-internal": "static-1.64156",
      "calling-lifecycle-messages": "static-1.56450",
      "commerce-products-lib": "static-1.8004",
      "conditional-properties-service-client": "static-1.3394",
      "external-options-client-types": "static-1.3613",
      "google-libphonenumber": "static-1.26",
      "inbounddb-objects-service-types": "static-1.3700",
      "meetings-icalendar-utils-lib": "static-1.19",
      "multi-currency-client-types": "static-1.3230",
      "object-builder-ui-client": "static-1.47095",
      "pipeline-validation-client-types": "static-1.3454",
      "property-value-citations": "static-1.528",
      "smart-property-lib": "static-1.4871",
      "tiered-pricing": "static-1.405",
      "ui-addon-form-validation": "static-1.10494",
      "directed-graph": "static-1.380",
      "event-emitter": "static-1.483",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3597",
      "video-components-external": "static-1.9804",
      "video-data-lib": "static-1.33462",
      "audio-components": "static-1.5278",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35224",
      "video-components": "static-1.11807",
      "video-embed": "static-1.34296",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23928",
      "knowledge-content-types": "static-1.8128",
      "payment-link-components": "static-1.22237",
      "ui-addon-emoji-picker": "static-1.9395",
      "call-summary": "static-1.37465",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8892",
      "batch-promise": "static-1.1083",
      "feature-store-service-types": "static-1.4091",
      "growth-monetization-service-types": "static-1.4098",
      "merchandise-lib": "static-1.247",
      "self-service-api": "static-1.9705",
      "upgrade-management-service-types": "static-1.4082",
      "chatspot-client-types": "static-1.10170",
      "chatspot-core": "static-1.19361",
      "ContentUtils": "static-1.66790",
      "copilot-toolkit": "static-1.9775",
      "growth-onboarding-feedback-components": "static-1.5966",
      "customer-data-sidebar": "static-2.44640",
      "enrichment-properties-lib": "static-1.13989",
      "persist-promise": "static-1.3240",
      "crm-pipelines-api-client-types": "static-1.3574",
      "customer-data-associations": "static-1.6756",
      "deal-intel-decorators": "static-1.405",
      "reporting-data": "static-1.65437",
      "ui-addon-draggable": "static-3.4302",
      "crm-record-cards-service-types": "static-1.3162",
      "crm_universal": "static-1.21305",
      "SalesContentIndexUI": "static-3.8374",
      "signup-ui-lego-core": "static-1.19865",
      "content-embed-lib": "static-1.6883",
      "data-model-builder-lib": "static-1.10678",
      "remote-ui": "static-1.54",
      "ui-components-test-utils": "static-1.5110",
      "ui-extensions-remote-renderer": "static-1.15740",
      "universal-page-editor-lib": "static-1.2515",
      "integrations-error-boundary-lib": "static-1.12031",
      "laboratory-lib": "static-3.6630",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9927",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8348",
      "messaging-types-lib": "static-1.44509",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15576",
      "sequences-client-types-lib": "static-1.7128",
      "foundations-components-test-utils": "static-1.4495",
      "magpie-lib": "static-1.5105",
      "navigation-messaging": "static-1.5866",
      "getting-started-shared-tasks": "static-1.17122",
      "getting-started-shared-tasks-store": "static-1.16240",
      "whatsapp-management-lib": "static-1.7344",
      "growth-data-modal": "static-1.4782",
      "growth-onboarding-confetti": "static-1.2544",
      "growth-onboarding-next-action-utils": "static-1.913",
      "navigation-components": "static-1.16539",
      "ui-shepherd-tracker": "static-1.6959",
      "shared-worker-versioning": "static-1.10556",
      "calling-orchestration-shared-library": "static-1.33987",
      "onboarding-scopes": "static-1.5978",
      "products-iframe-lib": "static-1.6592",
      "products-ui-components-shared-msw-handlers": "static-1.9128",
      "breeze-intelligence-kit": "static-1.4883",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8829",
      "fsm": "static-1.3186",
      "policy-lib": "static-1.6269",
      "react-tinymce": "static-1.53861",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52987",
      "tinymce-plugins": "static-1.56101",
      "tinymce-themes": "static-1.54957",
      "content-media-composition-data-lib": "static-1.10200",
      "content-media-compositions": "static-2.14207",
      "idb-keyval": "static-1.33",
      "magpie-types": "static-1.4565",
      "media-bridge-lib": "static-1.18131",
      "content-icons-ui": "static-1.2043",
      "social-insights-client-types": "static-1.20655",
      "outpost": "static-1.3791",
      "commerce-analytics-service-client": "static-1.3169",
      "ui-addon-opt": "static-4.7943",
      "commerce-tours-lib": "static-1.5283",
      "growth-onboarding-reliability": "static-1.4625",
      "sales-checkout-service-client": "static-1.3181",
      "ai-addon-copilot-preview": "static-1.6795",
      "calling-cross-tab-library": "static-1.18773",
      "wootric-nps": "static-1.6409",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4189",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2483",
      "card-payment-highlight-lib": "static-1.35754",
      "card-subscription-highlight-lib": "static-1.38145",
      "commerce-billing-lib": "static-1.17738",
      "commerce-contract-lib": "static-1.10281",
      "crm_components": "static-3.90360",
      "invoices-highlight-card-lib": "static-1.53168",
      "orders-highlight-card-lib": "static-1.20267",
      "products-highlight-card-lib": "static-1.16288",
      "project-storage": "static-1.4152",
      "quotes-highlight-card-lib": "static-1.70249",
      "usage-based-billing-components-lib": "static-1.7279",
      "deal-intel-utils": "static-1.409",
      "reporting-client-types": "static-1.2281",
      "react-flip-move": "static-1.59",
      "FireAlarmUi": "static-1.4096",
      "sales-templates-service-types-lib": "static-1.3738",
      "ui-asset-management-lib": "static-1.10259",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8889",
      "collaboration-sidebar": "static-1.56479",
      "data-model-commons-lib": "static-1.11240",
      "feedback-loader": "static-1.28278",
      "final-form": "static-1.58",
      "html-to-image": "static-1.42",
      "object-definition-builder-lib": "static-1.6521",
      "property-management-iframe": "static-1.11346",
      "reactflow": "static-1.49",
      "simple-data-table": "static-1.1316",
      "used-in-list-lib": "static-1.6376",
      "visual-association": "static-1.5307",
      "highcharts": "static-8.93",
      "reporting-visualizations": "static-1.57514",
      "ui-extensibility-client-types": "static-1.3521",
      "automation-platform-service-types": "static-1.2351",
      "ContentData": "static-1.66865",
      "email-portal-health-service-types": "static-1.522",
      "marketing-email-service-types": "static-1.1638",
      "reactive-lib": "static-1.233",
      "purchase-motions-components": "static-1.5005",
      "short-messages-app-service-client": "static-1.3533",
      "ui-tool-access": "static-1.9570",
      "calling-orchestration-schema": "static-1.34212",
      "sales-views-client-types": "static-1.3722",
      "trellis-story-utils": "static-1.4010",
      "storybook-react": "static-1.20",
      "hub-http-contrib": "static-1.2602",
      "interframe": "static-3.4237",
      "tinymce-data": "static-1.39072",
      "ui-addon-sales-email": "static-1.4697",
      "codemirror": "static-5.84",
      "layout-dnd-components": "static-1.11512",
      "layout-dnd-utils": "static-1.10487",
      "react-codemirror": "static-1.10138",
      "ui-brand-identity-lib": "static-1.12655",
      "NamespacedHubStyle": "static-2.8676",
      "hls.js": "static-1.28",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.4106",
      "ai-rendering-library": "static-1.8503",
      "ai-settings-ui-library": "static-1.6931",
      "chirp-fetch": "static-1.1438",
      "copilot-plugins": "static-1.9748",
      "commerce-shared-components-lib": "static-1.17153",
      "commerce-subscription-lib": "static-1.35722",
      "commerce-tools-ui-lib": "static-1.9161",
      "usage-tracker-session-replay": "static-1.4556",
      "utility-belt": "static-1.1978",
      "payments-enrollment-embed-lib": "static-1.21069",
      "quotes-ui-lib": "static-1.78966",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6205",
      "invoices-ui-lib": "static-1.53184",
      "commerce-products-api": "static-1.1478",
      "SafeStorage": "static-1.3839",
      "invoices-iframe-lib": "static-1.55242",
      "quotes-modal-lib": "static-1.100923",
      "reporting-ui-components": "static-2.62711",
      "subscription-experience-data-types": "static-1.14110",
      "association-translator": "static-1.2651",
      "crm-settings-header-lib": "static-1.7718",
      "settings-ui-nav": "static-2.9674",
      "chatspot-widget-iframe": "static-1.19353",
      "collaboration-sidebar-common": "static-1.1275",
      "property-management-common": "static-1.3633",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14374",
      "advanced-menus-lib": "static-1.11404",
      "ExportDialog": "static-6.9931",
      "ui-memberships-settings-lib": "static-1.32619",
      "nav-client-types": "static-1.1773",
      "purchase-motions-api": "static-1.5007",
      "trials-service-types": "static-1.3499",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8812",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12767",
      "highlight.js": "static-1.68",
      "reporting-action-components": "static-1.39916",
      "ui-addon-react-router-dom": "static-1.9072",
      "growth-onboarding-empty-states": "static-1.4991",
      "InboxConnectUtils": "static-4.13516",
      "payments-post-enroll-local-storage-lib": "static-1.4529",
      "qrcode-generator": "static-1.57",
      "amplitude-session-replay-browser": "static-1.49",
      "marketplace-ui-apps-core": "static-1.16715",
      "stripe-embedded-components": "static-1.6699",
      "products-ui-components": "static-1.38523",
      "totals-ui-components": "static-1.22200",
      "reporting-plugins": "static-1.9527",
      "reporting-reports": "static-1.65117",
      "reporting-snowflake": "static-1.54057",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14373",
      "simple-menus-lib": "static-1.15890",
      "eligibility-engine-service-types": "static-1.2780",
      "academy-common-lib": "static-1.12227",
      "dashboard-lib": "static-1.79542",
      "share-with-third-party-component-lib": "static-1.8187",
      "developer-experience-shared-components": "static-1.9895",
      "marketplace-ui-client-types": "static-1.15588",
      "marketplace-ui-common": "static-1.18181",
      "ui-addon-integrations-directory-panel": "static-2.7495",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3317",
      "commerce-totals-service-types": "static-1.3339",
      "campaign-roi-lib": "static-1.7428",
      "academy-service-client": "static-1.3113",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3438",
      "oauth-service-types": "static-1.3739",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27451",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7145",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8431",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15505",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12164",
      "conversations-message-history": "/conversations-message-history/static-1.11025",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9949",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20814",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5023",
      "hs-test-utils": "/hs-test-utils/static-1.7447",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10972",
      "I18n": "/I18n/static-7.1478",
      "jasmine-immutable": "/jasmine-immutable/static-1.2467",
      "jasmine-runner": "/jasmine-runner/static-1.5871",
      "quartz": "/quartz/static-1.6283",
      "react-dlb": "/react-dlb/static-1.64",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4008",
      "viral-links-lib": "/viral-links-lib/static-1.6446",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5661",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4113",
      "atom": "/atom/static-1.4630",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4279",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8454",
      "conversations-prop-types": "/conversations-prop-types/static-1.6879",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5240",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19551",
      "cssUtils": "/cssUtils/static-1.628",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.290",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16146",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4892",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3907",
      "sanitize-text": "/sanitize-text/static-1.7654",
      "signup-constants": "/signup-constants/static-1.17855",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "usage-tracker": "/usage-tracker/static-1.6870",
      "usage-tracker-core": "/usage-tracker-core/static-1.6720",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5284",
      "usage-tracker-public": "/usage-tracker-public/static-1.6681",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5472",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2994",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.61",
      "quartz-core": "/quartz-core/static-1.5502",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4321",
      "foundations-components": "/foundations-components/static-1.7011",
      "foundations-theming": "/foundations-theming/static-1.3858",
      "UIComponents": "/UIComponents/static-3.7919",
      "cv-backend-services": "/cv-backend-services/static-1.1383",
      "immutable-less": "/immutable-less/static-1.4058",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6805",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31642",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4154",
      "tanstack-virtual": "/tanstack-virtual/static-1.19",
      "ui-images": "/ui-images/static-2.990",
      "permission-components": "/permission-components/static-1.4817",
      "react-virtualized": "/react-virtualized/static-2.86",
      "HeadJS": "/HeadJS/static-2.641",
      "framer-motion": "/framer-motion/static-1.57",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2558",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.139",
      "i18n-data": "/i18n-data/static-1.211",
      "moment-timezone": "/moment-timezone/static-5.72",
      "jasmine": "/jasmine/static-4.3775",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7542",
      "HubStyle": "/HubStyle/static-2.11280",
      "sassPrefix": "/sassPrefix/static-1.145",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3483",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5287",
      "bender-build-tools": "/bender-build-tools/static-1.2637",
      "dispatcher": "/dispatcher/static-1.125",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.718",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8746",
      "hubspotter-http": "/hubspotter-http/static-1.4125",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8744",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.414",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "hs-story-utils": "/hs-story-utils/static-1.8866",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3280",
      "floating-ui": "/floating-ui/static-1.45",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1574",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2341",
      "foundations-theming-base": "/foundations-theming-base/static-1.2843",
      "stylex": "/stylex/static-1.21",
      "ts-schema": "/ts-schema/static-1.3659",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2001",
      "content-assistance-lib": "/content-assistance-lib/static-1.7110",
      "crm-component-utils": "/crm-component-utils/static-1.37778",
      "crm-display-components": "/crm-display-components/static-1.23528",
      "crm-fe-perf": "/crm-fe-perf/static-1.22431",
      "crm-links": "/crm-links/static-1.5683",
      "crm-message-bus": "/crm-message-bus/static-1.41610",
      "crm-search-service-types": "/crm-search-service-types/static-1.753",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4768",
      "customer-data-communicator": "/customer-data-communicator/static-1.44158",
      "customer-data-email": "/customer-data-email/static-1.17124",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37925",
      "customer-data-objects": "/customer-data-objects/static-1.7140",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12491",
      "customer-data-properties": "/customer-data-properties/static-1.49914",
      "customer-data-rte": "/customer-data-rte/static-1.31779",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9265",
      "data-fetching-client": "/data-fetching-client/static-1.9173",
      "draft-plugins": "/draft-plugins/static-2.20754",
      "file-manager-components": "/file-manager-components/static-1.22073",
      "FileManagerCore": "/FileManagerCore/static-1.37572",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7453",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4309",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16843",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9417",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7542",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17151",
      "universal-associations-select": "/universal-associations-select/static-1.10470",
      "graphql": "/graphql/static-1.71",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7583",
      "superstore": "/superstore/static-1.4228",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8263",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27164",
      "card-properties-lib": "/card-properties-lib/static-1.42768",
      "crm-actions": "/crm-actions/static-1.5683",
      "crm-cards-data": "/crm-cards-data/static-1.628",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42122",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8073",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7492",
      "customer-data-tracking": "/customer-data-tracking/static-1.6382",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6332",
      "usage-tracker-container": "/usage-tracker-container/static-1.6860",
      "framework-data-table": "/framework-data-table/static-2.10769",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7716",
      "calling-error-reporting": "/calling-error-reporting/static-1.30811",
      "calling-internal-common": "/calling-internal-common/static-1.30805",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6017",
      "crm_data": "/crm_data/static-4.90360",
      "crm_schema": "/crm_schema/static-3.90399",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23296",
      "customer-data-content": "/customer-data-content/static-1.26315",
      "draft-content-plugins": "/draft-content-plugins/static-1.27156",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23143",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22851",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23412",
      "FileManagerLib": "/FileManagerLib/static-1.37713",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16835",
      "integration-settings-components": "/integration-settings-components/static-1.13892",
      "integrations-lib": "/integrations-lib/static-1.14616",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5120",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7269",
      "nav-meta": "/nav-meta/static-1.28176",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5241",
      "property-translator": "/property-translator/static-1.4869",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36335",
      "react-colorpicker": "/react-colorpicker/static-2.9726",
      "react-dnd-compat": "/react-dnd-compat/static-1.4114",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7707",
      "rich-text-lib": "/rich-text-lib/static-1.18894",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3386",
      "sequences-lib": "/sequences-lib/static-1.7271",
      "timezone-utils": "/timezone-utils/static-2.4682",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10516",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8419",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8444",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9762",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9578",
      "user-context": "/user-context/static-1.4627",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4185",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4192",
      "salesImages": "/salesImages/static-1.514",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20359",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12557",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4171",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3548",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6237",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3233",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3457",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.500",
      "onboarding-tours": "/onboarding-tours/static-1.15892",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12178",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
      "ui-addon-teams": "/ui-addon-teams/static-1.20865",
      "calling-global-api": "/calling-global-api/static-1.62774",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64156",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56450",
      "commerce-products-lib": "/commerce-products-lib/static-1.8004",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3394",
      "external-options-client-types": "/external-options-client-types/static-1.3613",
      "google-libphonenumber": "/google-libphonenumber/static-1.26",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3700",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.19",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3230",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47095",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3454",
      "property-value-citations": "/property-value-citations/static-1.528",
      "smart-property-lib": "/smart-property-lib/static-1.4871",
      "tiered-pricing": "/tiered-pricing/static-1.405",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10494",
      "directed-graph": "/directed-graph/static-1.380",
      "event-emitter": "/event-emitter/static-1.483",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3597",
      "video-components-external": "/video-components-external/static-1.9804",
      "video-data-lib": "/video-data-lib/static-1.33462",
      "audio-components": "/audio-components/static-1.5278",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35224",
      "video-components": "/video-components/static-1.11807",
      "video-embed": "/video-embed/static-1.34296",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23928",
      "knowledge-content-types": "/knowledge-content-types/static-1.8128",
      "payment-link-components": "/payment-link-components/static-1.22237",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9395",
      "call-summary": "/call-summary/static-1.37465",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8892",
      "batch-promise": "/batch-promise/static-1.1083",
      "feature-store-service-types": "/feature-store-service-types/static-1.4091",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4098",
      "merchandise-lib": "/merchandise-lib/static-1.247",
      "self-service-api": "/self-service-api/static-1.9705",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4082",
      "chatspot-client-types": "/chatspot-client-types/static-1.10170",
      "chatspot-core": "/chatspot-core/static-1.19361",
      "ContentUtils": "/ContentUtils/static-1.66790",
      "copilot-toolkit": "/copilot-toolkit/static-1.9775",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5966",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44640",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13989",
      "persist-promise": "/persist-promise/static-1.3240",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3574",
      "customer-data-associations": "/customer-data-associations/static-1.6756",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.405",
      "reporting-data": "/reporting-data/static-1.65437",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4302",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3162",
      "crm_universal": "/crm_universal/static-1.21305",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8374",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19865",
      "content-embed-lib": "/content-embed-lib/static-1.6883",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10678",
      "remote-ui": "/remote-ui/static-1.54",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5110",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15740",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2515",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12031",
      "laboratory-lib": "/laboratory-lib/static-3.6630",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9927",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8348",
      "messaging-types-lib": "/messaging-types-lib/static-1.44509",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15576",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7128",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4495",
      "magpie-lib": "/magpie-lib/static-1.5105",
      "navigation-messaging": "/navigation-messaging/static-1.5866",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17122",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16240",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7344",
      "growth-data-modal": "/growth-data-modal/static-1.4782",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2544",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.913",
      "navigation-components": "/navigation-components/static-1.16539",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6959",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10556",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33987",
      "onboarding-scopes": "/onboarding-scopes/static-1.5978",
      "products-iframe-lib": "/products-iframe-lib/static-1.6592",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9128",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4883",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8829",
      "fsm": "/fsm/static-1.3186",
      "policy-lib": "/policy-lib/static-1.6269",
      "react-tinymce": "/react-tinymce/static-1.53861",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52987",
      "tinymce-plugins": "/tinymce-plugins/static-1.56101",
      "tinymce-themes": "/tinymce-themes/static-1.54957",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10200",
      "content-media-compositions": "/content-media-compositions/static-2.14207",
      "idb-keyval": "/idb-keyval/static-1.33",
      "magpie-types": "/magpie-types/static-1.4565",
      "media-bridge-lib": "/media-bridge-lib/static-1.18131",
      "content-icons-ui": "/content-icons-ui/static-1.2043",
      "social-insights-client-types": "/social-insights-client-types/static-1.20655",
      "outpost": "/outpost/static-1.3791",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3169",
      "ui-addon-opt": "/ui-addon-opt/static-4.7943",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5283",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4625",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3181",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6795",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18773",
      "wootric-nps": "/wootric-nps/static-1.6409",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4189",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2483",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35754",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38145",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17738",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10281",
      "crm_components": "/crm_components/static-3.90360",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53168",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20267",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16288",
      "project-storage": "/project-storage/static-1.4152",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70249",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7279",
      "deal-intel-utils": "/deal-intel-utils/static-1.409",
      "reporting-client-types": "/reporting-client-types/static-1.2281",
      "react-flip-move": "/react-flip-move/static-1.59",
      "FireAlarmUi": "/FireAlarmUi/static-1.4096",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3738",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10259",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8889",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56479",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11240",
      "feedback-loader": "/feedback-loader/static-1.28278",
      "final-form": "/final-form/static-1.58",
      "html-to-image": "/html-to-image/static-1.42",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6521",
      "property-management-iframe": "/property-management-iframe/static-1.11346",
      "reactflow": "/reactflow/static-1.49",
      "simple-data-table": "/simple-data-table/static-1.1316",
      "used-in-list-lib": "/used-in-list-lib/static-1.6376",
      "visual-association": "/visual-association/static-1.5307",
      "highcharts": "/highcharts/static-8.93",
      "reporting-visualizations": "/reporting-visualizations/static-1.57514",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3521",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2351",
      "ContentData": "/ContentData/static-1.66865",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.522",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1638",
      "reactive-lib": "/reactive-lib/static-1.233",
      "purchase-motions-components": "/purchase-motions-components/static-1.5005",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3533",
      "ui-tool-access": "/ui-tool-access/static-1.9570",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34212",
      "sales-views-client-types": "/sales-views-client-types/static-1.3722",
      "trellis-story-utils": "/trellis-story-utils/static-1.4010",
      "storybook-react": "/storybook-react/static-1.20",
      "hub-http-contrib": "/hub-http-contrib/static-1.2602",
      "interframe": "/interframe/static-3.4237",
      "tinymce-data": "/tinymce-data/static-1.39072",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4697",
      "codemirror": "/codemirror/static-5.84",
      "layout-dnd-components": "/layout-dnd-components/static-1.11512",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10487",
      "react-codemirror": "/react-codemirror/static-1.10138",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12655",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8676",
      "hls.js": "/hls.js/static-1.28",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4106",
      "ai-rendering-library": "/ai-rendering-library/static-1.8503",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6931",
      "chirp-fetch": "/chirp-fetch/static-1.1438",
      "copilot-plugins": "/copilot-plugins/static-1.9748",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17153",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35722",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9161",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4556",
      "utility-belt": "/utility-belt/static-1.1978",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21069",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78966",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6205",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53184",
      "commerce-products-api": "/commerce-products-api/static-1.1478",
      "SafeStorage": "/SafeStorage/static-1.3839",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55242",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100923",
      "reporting-ui-components": "/reporting-ui-components/static-2.62711",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14110",
      "association-translator": "/association-translator/static-1.2651",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7718",
      "settings-ui-nav": "/settings-ui-nav/static-2.9674",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19353",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1275",
      "property-management-common": "/property-management-common/static-1.3633",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14374",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11404",
      "ExportDialog": "/ExportDialog/static-6.9931",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32619",
      "nav-client-types": "/nav-client-types/static-1.1773",
      "purchase-motions-api": "/purchase-motions-api/static-1.5007",
      "trials-service-types": "/trials-service-types/static-1.3499",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8812",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12767",
      "highlight.js": "/highlight.js/static-1.68",
      "reporting-action-components": "/reporting-action-components/static-1.39916",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9072",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4991",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13516",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4529",
      "qrcode-generator": "/qrcode-generator/static-1.57",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.49",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16715",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6699",
      "products-ui-components": "/products-ui-components/static-1.38523",
      "totals-ui-components": "/totals-ui-components/static-1.22200",
      "reporting-plugins": "/reporting-plugins/static-1.9527",
      "reporting-reports": "/reporting-reports/static-1.65117",
      "reporting-snowflake": "/reporting-snowflake/static-1.54057",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14373",
      "simple-menus-lib": "/simple-menus-lib/static-1.15890",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2780",
      "academy-common-lib": "/academy-common-lib/static-1.12227",
      "dashboard-lib": "/dashboard-lib/static-1.79542",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8187",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9895",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15588",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18181",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7495",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3317",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3339",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7428",
      "academy-service-client": "/academy-service-client/static-1.3113",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3438",
      "oauth-service-types": "/oauth-service-types/static-1.3739",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};